<template>
  <div class="stepContainer text-center">
    <v-tooltip top :disabled="!step.sigMessageModel">
      <template v-slot:activator="{ on }">
        <v-btn
          class="stepButton mb-1"
          :class="getStepButtonClass(step)"
          fab
          small
          :color="getStepColor(step, step.status)"
          @click.stop.prevent="$emit('specific-step', stepIndex)"
          v-on="on"
        >
          <v-icon :color="getStepIconColor(step)">{{ getStepIcon(step) }}</v-icon>
        </v-btn>
      </template>
      <span v-if="step.sigMessageModel">{{ step.sigMessageModel.message }}</span>
    </v-tooltip>
    <div class="stepText sigfloButtonSmall400" :class="getStepTextClass(step)">
      {{ step.label }}
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      step: Object,
      stepIndex: Number
    },
    data() {
      return {};
    },
    methods: {
      /**
       * Returns the CSS class for the step text based on the step status.
       * @param {Object} step - The step object.
       * @returns {string} - The CSS class for the step text.
       */
      getStepTextClass: function (step) {
        let textClass = step.status == 'None' ? 'textMutedLight' : 'textEmphasisLight';
        if (this.isCurrentStep(step)) textClass += ' currentStepText';
        return textClass;
      },
      /**
       * Returns the color for the step icon based on the step's status.
       * @param {Object} step - The step object.
       * @returns {string} The color code for the step icon.
       */
      getStepIconColor: function (step) {
        let color = '#FAFAFB';
        switch (step.status) {
          case 'Valid':
            color = '#110B19';
            break;
          case 'None':
            color = '#BCB2CD';
            break;
          default:
            color = '#FAFAFB';
        }
        if (this.isCurrentStep(step)) color = '#FAFAFB';
        return color;
      },
      /**
       * Returns the color for a specific step based on its status and current subsystem step.
       *
       * @param {Object} step - The step object.
       * @param {string} status - The status of the step (Valid, Warning, Error).
       * @returns {string} - The color code for the step.
       */
      getStepColor: function (step, status) {
        let color = '#200c40';
        if (status === 'Valid') color = '#32FF98';
        else if (status === 'Warning') color = '#ffbd39';
        else if (status === 'Error') color = '#f52b40';

        if (this.isCurrentStep(step)) color = '#401881';

        return color;
      },
      /**
       * Returns the CSS class name for the button associated with the given step.
       * The class name is determined based on the step's status and whether it is the current step.
       *
       * @param {Object} step - The step object containing the status and other properties.
       * @returns {string} - The CSS class name for the button.
       */
      getStepButtonClass: function (step) {
        let className = 'incompleteButton';
        if (step.status === 'Valid') className = 'validButton';
        else if (step.status === 'Warning') className = 'warningButton';
        else if (step.status === 'Error') className = 'errorButton';

        if (this.isCurrentStep(step)) className = 'currentButton';

        return className;
      },
      /**
       * Returns the icon name based on the status of the given step.
       * @param {Object} step - The step object containing the status and component definition ID.
       * @returns {string} - The icon name corresponding to the step status.
       */
      getStepIcon: function (step) {
        let iconName = '';

        switch (step.status) {
          case 'Valid':
            iconName = 'mdi-check';
            break;
          case 'None':
            iconName = 'mdi-minus';
            break;
          default:
            iconName = 'mdi-alert';
        }
        if (this.isCurrentStep(step)) iconName = 'mdi-arrow-up';
        return iconName;
      }
    }
  };
</script>

<style scoped>
  .incompleteButton {
    border: 1px solid #c4a9ef !important;
    transform: scale(0.7);
  }
  .validButton {
    border: 1px solid #32ff98 !important;
    transform: scale(0.7);
  }
  .currentButton {
    border: 2px solid #c4a9ef !important;
    transform: scale(1.4);
  }
  .currentStepText {
    font-size: 16px;
    padding-top: 8px;
  }
  .noneButton {
    border: 1px solid #bcb2cd !important;
  }
  .warningButton {
    border: 1px solid #ffbd39 !important;
  }
  .errorButton {
    border: 2px solid #f52b40 !important;
  }

  .stepContainer {
    margin-top: 0px;
  }
</style>
